<!-- 答题报告 -->
<template>
  <div class="answer-report-wrap">
    <div class="result-wrap">
      <div class="result-wrap-bg"></div>
      <div class="result-info">
        <div class="result-item accuracy" v-if="workInfo.show_accuracy === 1">
          <p>
            <span class="percent">{{ handleAccuracy }}</span>
            <span class="sign">%</span>
          </p>
          <p class="item-name">正确率</p>
        </div>
        <div class="result-item accuracy" v-else>
          <p>
            <span class="percent">{{ workInfo.score || 0 }}</span>
            <!-- <span class="sign">分</span> -->
          </p>
          <p class="item-name">分数</p>
        </div>
        <div class="result-item question-num">
          <p class="num">{{ questionList.length }}</p>
          <p class="item-name">题数/道</p>
        </div>
        <div v-if="workInfo.sub_time" class="result-item total-duration">
          <p class="num">{{ handleTotalDuration.value }}</p>
          <p class="item-name">总用时/{{ handleTotalDuration.unit }}</p>
        </div>
      </div>
      <div class="work-info">
        <p class="info-item">
          <span class="info-name">作业名称</span>
          <span class="info-value"> {{ workInfo.homework_name }}</span>
        </p>
        <p class="info-item">
          <span class="info-name">交卷时间</span>
          <span v-if="workInfo.sub_time" class="info-value">{{
            moment(workInfo.sub_time * 1000).format("YYYY-MM-DD HH:mm:ss")
          }}</span>
        </p>
      </div>
    </div>
    <div class="answer-sheet-wrap">
      <div class="title-wrap">
        <p class="title">答题卡</p>
        <ul class="round-list">
          <li class="right">
            <span class="round"></span>
            <span class="status">正确</span>
          </li>
          <li class="wrong">
            <span class="round"></span>
            <span class="status">错误</span>
          </li>
          <li class="empty">
            <span class="round"></span>
            <span class="status">未答</span>
          </li>
        </ul>
      </div>

      <ul class="number-wrap">
        <li
          @click="handleNumberClick(item)"
          class="number-item"
          v-for="(item, index) in questionList"
          :key="item.question_id"
          :class="{
            'is-answer': item.is_answer,
            'is-right': isCorrected && item.is_answer && item.is_right,
            'is-wrong': isCorrected && item.is_answer && !item.is_right,
          }"
        >
          {{ index + 1 }}
        </li>
      </ul>
    </div>

    <div v-if="false" class="btns-wrap">
      <button
        v-preventReClick
        class="error-analysis"
        @click="showErrorAnalysis"
      >
        错题解析
      </button>
      <button v-preventReClick class="all-analysis" @click="showAnalysis">
        全部解析
      </button>
    </div>
  </div>
</template>

<script>
import { EventBus } from "@saas/components/src/utils/event-bus";
import AnswerReport from "../mixins/answer-report.js";
export default {
  mixins: [AnswerReport],
  methods: {
    handleNumberClick(item) {
      EventBus.$emit(`answer-sheet-auto-next-question`, item);
    },
  },
};
</script>

<style lang="scss" scoped>
.answer-report-wrap {
  --homework-report-card-bg: #ffffff;
  --homework-report-surface-bg: #f2f3f5;
  --homework-report-primary: #1d2129;
  --homework-report-secondary: #4e5969;
  --homework-report-border: #f2f3f5;
  --homework-report-button-border: #e5e6eb;

  html.dark & {
    --homework-report-card-bg: var(--mg-bg-card);
    --homework-report-surface-bg: var(--mg-control-bg);
    --homework-report-primary: var(--mg-text-primary);
    --homework-report-secondary: var(--mg-text-secondary);
    --homework-report-border: var(--mg-border-subtle);
    --homework-report-button-border: var(--mg-border-subtle);
  }

  .result-wrap {
    position: relative;
    display: flex;
    align-items: center;
    width: 1200px;
    height: 140px;
    background: var(--homework-report-card-bg);
    border-radius: 12px;
    margin: 0 auto 20px;
  }
  .result-info {
    position: relative;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    .item-name {
      font-weight: 400;
      font-size: 14px;
      color: var(--homework-report-secondary);
      line-height: 20px;
      margin-top: 2px;
    }
    .accuracy {
      margin-right: 120px;
    }
    .question-num {
      margin-right: 45px;
    }
    .percent {
      font-family: AvenirLTPro;
      font-weight: 500;
      font-size: 40px;
      color: #386bff;
      line-height: 48px;
    }
    .sign {
      font-weight: 500;
      font-size: 17px;
      color: #386bff;
      line-height: 20px;
    }
    .num {
      font-family: AvenirLTPro;
      font-weight: 500;
      font-size: 24px;
      color: var(--homework-report-primary);
      line-height: 29px;
    }
  }
  .work-info {
    position: relative;
    width: 445px;
    padding-left: 30px;
    border-left: 1px solid var(--homework-report-border);
    .info-name {
      font-weight: 400;
      font-size: 14px;
      color: var(--homework-report-secondary);
      line-height: 20px;
      margin-right: 14px;
    }
    .info-value {
      font-weight: 400;
      font-size: 14px;
      color: var(--homework-report-primary);
      line-height: 20px;
      max-width: 240px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      flex: 1;
    }
    .info-item {
      display: flex;
      align-items: center;
      margin-bottom: 12px;
    }
    .info-item:last-child {
      margin-bottom: 0;
    }
  }
  .result-wrap-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 82px;
    background: linear-gradient(180deg, #0061eb 0%, rgba(34, 91, 228, 0) 100%);
    border-radius: 12px 12px 0px 0px;
    opacity: 0.1;
  }

  .answer-sheet-wrap {
    width: 1200px;
    margin: 0 auto 40px;
    background: var(--homework-report-card-bg);
    border-radius: 12px;
    .title-wrap {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 32px 30px 20px;
    }
    .number-wrap {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      padding: 0 15px 25px;
    }
    .number-item {
      width: 30px;
      height: 30px;
      background: var(--homework-report-surface-bg);
      font-weight: 500;
      font-size: 16px;
      color: var(--homework-report-secondary);
      line-height: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      margin: 0 15px 20px;
      cursor: pointer;
      &.is-answer {
        background: $homework-default-bg;
        color: $homework-default-color;
      }
      &.is-right {
        background: $homework-right-bg;
        color: $homework-right-color;
      }
      &.is-wrong {
        background: $homework-wrong-bg;
        color: $homework-wrong-color;
      }
    }
    .title {
      font-weight: 600;
      font-size: 16px;
      color: var(--homework-report-primary);
      line-height: 22px;
    }
    .round-list {
      display: flex;
      align-items: center;
      li {
        display: flex;
        align-items: center;
        margin-right: 10px;
        &:last-child {
          margin-right: 0;
        }
      }
      .round {
        width: 8px;
        height: 8px;
        background: $homework-right-color;
        margin-right: 5px;
        border-radius: 50%;
      }
      .status {
        font-weight: 400;
        font-size: 14px;
        color: $homework-right-color;
        line-height: 20px;
      }
    }
    .wrong {
      .round {
        background: #f76560;
      }
      .status {
        color: #f76560;
      }
    }
    .empty {
      .round {
        background: #c9cdd4;
      }
      .status {
        color: #c9cdd4;
      }
    }
  }

  .btns-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
    button {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 160px;
      height: 40px;
      background: var(--homework-report-card-bg);
      border-radius: 20px;
      border: 1px solid var(--homework-report-button-border);
      font-weight: 500;
      font-size: 16px;
      color: var(--homework-report-primary);
      line-height: 22px;
    }
    .all-analysis {
      border: 1px solid #bedaff;
      color: $homework-default-color;
      margin-left: 24px;
    }
  }
}

// 适配
@media (max-width: 1200px) {
  .answer-report-wrap {
    .result-wrap {
      width: calc(100% - 30px);
      // flex-direction: column;
    }
    .answer-sheet-wrap {
      width: calc(100% - 30px);
    }
  }
}
@media (max-width: 900px) {
  .answer-report-wrap {
    .result-wrap {
      padding: 0 10px;
    }
    .result-info {
      justify-content: space-around;
      .result-item {
        margin-right: 0;
      }
    }
    .work-info {
      flex: 1;
      width: auto;
    }
  }
}
@media (max-width: 600px) {
  .answer-report-wrap {
    .result-wrap {
      height: auto;
      padding: 20px 10px;
      flex-direction: column;
    }
    .result-info {
      justify-content: space-around;
      .result-item {
        margin-right: 0;
      }
    }
    .result-info,
    .work-info {
      flex: none;
      width: 100%;
    }
    .work-info {
      margin-top: 20px;
      border-left: none;
    }
  }
}
</style>
